import { render } from "./PromoData.vue?vue&type=template&id=78715b06&scoped=true"
import script from "./PromoData.vue?vue&type=script&lang=js"
export * from "./PromoData.vue?vue&type=script&lang=js"

import "./PromoData.vue?vue&type=style&index=0&id=78715b06&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78715b06"]])

export default __exports__